/**
 * Career Development User Styling Utilities
 * Based on the original chat.js pattern for career development users
 *
 * From chat.js lines 2882-2885:
 * if (self.userCareerDevelopment) {
 *     var coachTextBtn = $('<a href="javascript:;" class="btn-text" title="' + self.t("text_chat", "Text Chat") + '"><i class="el-icon-comment" aria-label="text" title="text" alt="Ask a career coach icon" style="margin-bottom:10px;"></i></a>');
 *     var linkColor = "#AAFFFF";
 * }
 */

/**
 * Get career development specific icon alt text translation key
 * @param {boolean} userCareerDevelopment - Whether user is career development
 * @returns {string} Translation key for icon alt text
 */
export const getCareerDevelopmentIconAltKey = (userCareerDevelopment) => {
  if (userCareerDevelopment) {
    return 'career_development.icon_alt'
  }

  return 'CoachChatList.icon_alt'
}

/**
 * Get career development specific class names
 * @param {boolean} userCareerDevelopment - Whether user is career development
 * @param {string} baseClassName - Base class name to extend
 * @returns {string} Combined class name with career development styling
 */
export const getCareerDevelopmentClassName = (
  userCareerDevelopment,
  baseClassName = '',
) => {
  if (userCareerDevelopment) {
    // Add career development button class and color override with important
    // Original linkColor was #AAFFFF
    return `${baseClassName} career-development-button !text-[#AAFFFF] hover:!text-[#AAFFFF]`.trim()
  }

  return baseClassName
}
